import { createReducer, on } from '@ngrx/store';
import { cloneDeep, omit } from 'lodash';
import { ReportViewTraitActions } from './trait.actions';
import {
  ReportViewTraitState,
  initialReportViewTraitState,
  reportViewTraitState
} from './trait.state';

export const reportViewTraitReducer = createReducer(
  reportViewTraitState,
  on(
    ReportViewTraitActions.reset,
    (): ReportViewTraitState => cloneDeep(initialReportViewTraitState)
  ),
  on(
    ReportViewTraitActions.updateReportType,
    (state, { reportType }): ReportViewTraitState => ({
      ...state,
      filters: {
        ...state.filters,
        where: {
          ...state.filters.where,
          reportType: reportType as any
        }
      }
    })
  ),
  on(
    ReportViewTraitActions.updateFilter,
    (state, { limit, offset, sort, where }): ReportViewTraitState => ({
      ...state,
      filters: {
        ...state.filters,
        limit: limit ?? state.filters.limit,
        offset: offset ?? state.filters.offset,
        sort: {
          ...state.filters.sort,
          ...sort
        },
        where: {
          ...state.filters.where,
          ...where
        }
      }
    })
  ),
  on(
    ReportViewTraitActions.updateFilterKeyword,
    (state, { keyword }): ReportViewTraitState => ({
      ...state,
      filters: {
        ...state.filters,
        where: {
          ...state.filters.where,
          keyword
        }
      }
    })
  ),
  on(
    ReportViewTraitActions.updateSort,
    (state, sort): ReportViewTraitState => ({
      ...state,
      filters: {
        ...state.filters,
        sort: omit(sort, ['type'])
      }
    })
  ),
  on(
    ReportViewTraitActions.resetFilter,
    (state): ReportViewTraitState => ({
      ...state,
      filters: {
        ...state.filters,
        limit: state.filters.limit,
        offset: state.filters.offset,
        sort: {},
        where: {}
      }
    })
  ),
  on(
    ReportViewTraitActions.setTraitLoading,
    (state, { loading }): ReportViewTraitState => ({
      ...state,
      loading: {
        ...state.loading,
        trait: loading
      }
    })
  ),
  on(
    ReportViewTraitActions.setTrait,
    (state, { results, count }): ReportViewTraitState => ({
      ...state,
      trait: {
        results,
        count
      }
    })
  )
);
